module.exports = __webpack_public_path__ + "static/media/urbanplanning.328f9abb.jpg";